import { render } from "./LandingPageSettingsDropdown.vue?vue&type=template&id=bd6be01c&scoped=true"
import script from "./LandingPageSettingsDropdown.vue?vue&type=script&lang=js"
export * from "./LandingPageSettingsDropdown.vue?vue&type=script&lang=js"

import "./LandingPageSettingsDropdown.vue?vue&type=style&index=0&id=bd6be01c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd6be01c"]])

export default __exports__